const parisDateFormatter = new Intl.DateTimeFormat("sv-SE", {
  timeZone: "Europe/Paris",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

/** Jour civil de l'entreprise, indépendant du fuseau de l'appareil. */
export function parisCalendarDay(value: Date | string = new Date()) {
  return parisDateFormatter.format(new Date(value));
}

/** Mois civil de l'entreprise au format attendu par les champs month. */
export function parisCalendarMonth(value: Date | string = new Date()) {
  return parisCalendarDay(value).slice(0, 7);
}
